let instance;
function setInstance(sound) {
  instance = sound;
  return sound;
}
function getInstance() {
  return instance;
}

export { getInstance, instance, setInstance };
//# sourceMappingURL=instance.mjs.map
